import styled from "styled-components";

export const ModalBlackFridayContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 99999;

  display: flex;
  align-items: center;
  justify-content: center;

  background: none;
  backdrop-filter: blur(4px);

  .content {
    position: relative;
    width: min(900px, 90vw);
    padding: 60px 40px;

    border-radius: 20px;
    overflow: hidden;

    background: rgb(0,0,0);
    background-size: cover;
    background-position: center;

    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  }

  .call1 {
    color: #ff4b2b;
    font-size: 48px;
    font-weight: 900;
    margin-bottom: 10px;
    text-transform: uppercase;
  }

  .call2 {
    color: #fff;
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 4px;
    letter-spacing: 1px;
  }

  .call3 {
    color: #fff;
    font-size: 36px;
    font-weight: 800;
    margin-bottom: 30px;
  }

  .countdown {
    margin-bottom: 30px;
  }

  .call4 {
    background: linear-gradient(90deg, #ff4b2b, #ff9800);
    padding: 14px 40px;
    border-radius: 50px;
    border: none;
    cursor: pointer;

    text-transform: uppercase;
    font-weight: 700;
    font-size: 18px;
    color: #fff;

    transition: 0.2s;
  }

  .call4:hover {
    transform: translateY(-2px);
    filter: brightness(1.1);
  }

  .closeButton {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 38px;
    height: 38px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    cursor: pointer;

    transition: 0.2s;
  }

  .closeButton:hover {
    background: rgba(0, 0, 0, 0.7);
    transform: scale(1.1);
  }

  .closeButton svg {
    width: 22px;
    height: 22px;
    color: #fff;
  }

  @media (max-width: 600px) {
    .call1 {
      font-size: 32px;
    }

    .call3 {
      font-size: 28px;
    }

    .call4 {
      width: 90%;
    }
  }
`;